import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TestimonialsCarousel from './TestimonialsCarousel';

const logo =
  'https://res.cloudinary.com/dwoubdppz/image/upload/v1751597827/oak-and-stone-remodel/logo/logo.svg';

export const Footer = () => {
  const { currentUser, logout } = useAuth();

  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
      {/* Testimonials Carousel */}
      <TestimonialsCarousel />

      <div className="pt-10 text-center bg-[#D9D9D9]  bg-opacity-10 border-t border-black border-opacity-40 relative">
        <Link to="/" onClick={handleLogoClick}>
          <img
            src={logo}
            alt="oak and stone logo"
            className="mx-auto mb-8 h-16"
          />
        </Link>

        <p className="py-6">
          Home Remodeling & Renovations Experts <br></br> Serving Weber, Davis,
          and Box Elder counties, Utah.
        </p>
        <p className="pb-6">
          {' '}
          &copy; {new Date().getFullYear()} Oak and Stone. All rights reserved.
        </p>

        {/* Admin Login/Logout Section */}
        <div className="pb-4 mt-4">
          {currentUser ? (
            <div className="flex justify-center items-center space-x-4 text-sm text-gray-600">
              <span>Welcome, {currentUser.email}</span>
              <button
                onClick={handleLogout}
                className="underline text-primary hover:text-primary-hover">
                Logout
              </button>
            </div>
          ) : (
            <div className="text-center">
              <Link
                to="/login"
                className="inline-block text-xs text-gray-500 underline hover:text-gray-700">
                Admin Login
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
